import { app, usersService } from '../index';

export async function signup(payload) {
  try {
    return await usersService.create(payload);
  } catch (err) {
    return err.message;
  }
}

export async function login(payload, strategy) {
  try {
    return await app.authenticate({
      strategy: strategy,
      ...payload
    });
  } catch (err) {
    return err.message;
  }
}

export function logout() {
  return app.logout();
}

export async function updateUser(id, payload) {
  try {
    return await usersService.patch(id, payload);
  } catch (err) {
    return {};
  }
}

export async function getUser(id) {
  try {
    return await usersService.get(id);
  } catch (err) {
    return {};
  }
}



// WEBPACK FOOTER //
// ./src/modules/user/api.js